export const SET = 'agreements/SET';
